import React, {useState} from 'react';

const AgentIndexContent = ({ data }) => {
    const tableData = (data?.user_fill ?? []).map(item => JSON.parse(item.value_data));

    const [limit, setLimit] = useState(15)
    const passedLimit = tableData.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 15)
    }

    const columns = [
        {
            key: "user_name",
            label: "Agente",
            getter: row => row.user_name,
            alwaysVisible: true,
        },
        {
            key: "nature",
            label: "Natureza",
            getter: row => row.table_values?.nature,
        },
        {
            key: "obs",
            label: "Obs. inicial",
            getter: row => row.table_values?.obs,
        },
        {
            key: "obs_final",
            label: "Obs. final",
            getter: row => row.table_values?.obs_final,
        },
        {
            key: "place",
            label: "Local pré-cadastrado",
            getter: row => row.table_values?.place,
        },
        {
            key: "street",
            label: "Logradouro",
            getter: row => row.table_values?.street,
        },
        {
            key: "number",
            label: "Número",
            getter: row => row.table_values?.number,
        },
        {
            key: "neighborhood",
            label: "Bairro",
            getter: row => row.table_values?.neighborhood,
        },
        {
            key: "sector",
            label: "Setor",
            getter: row => row.table_values?.sector,
        },
        {
            key: "lat",
            label: "Latitude/Longitude",
            getter: row => row.table_values?.lat,
        }
    ];

    const visibleColumns = columns.filter(column =>
        column.alwaysVisible || tableData.some(row => {
            const value = column.getter(row);
            return value !== null && value !== undefined && value !== "";
        })
    );

    if (tableData?.length === 0) return null;

    return (
        <>
            <div>
                <div className="chart mt-3">
                    <span className="chart-title">
                        Índices de preenchimento por agente {(passedLimit && limit) ? `(TOP ${limit})` : ""}
                    </span>
                </div>

                <table id="agent-index-data" className="table report-table mt-2">
                    <thead className="thead-background table-break-word">
                        <tr className="text-left">
                            { visibleColumns.map(column => (
                                <th key={column.key} style={{ width: `${100 / visibleColumns.length}%` }}>
                                    {column.label}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody className="bg-white">
                        { (limit ? tableData.slice(0, limit) : tableData).map((element, index) => (
                            <tr key={index}>
                                {visibleColumns.map(column => {
                                    const value = column.getter(element);

                                    return (
                                        <td key={column.key} style={{ width: `${100 / visibleColumns.length}%` }}>
                                            {column.alwaysVisible ? value : (value ?? "")}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>

                { passedLimit &&
                    <div className="text-end mt-1">
                        <span id="toggle-nature" className="see-more print-hide" onClick={seeMoreOrLess}>
                            { limit ? "Ver mais" : "Ver menos" }
                        </span>
                    </div>
                }

            </div>
        </>
    );
};

export default AgentIndexContent;